var Credential = /** @class */ (function () {
    function Credential(_a) {
        var id = _a.id, datasets = _a.datasets;
        this.id = id;
        this.datasets = datasets;
    }
    Credential.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, datasets = _a.attributes.datasets;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        return new Credential({
            id: id,
            datasets: datasets,
        });
    };
    return Credential;
}());
export default Credential;
